//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    //搜索数据
    listD: {
      type: Array,
      required: true
    },
    //關鍵詞
    keyWord: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      img_lazyload: require("@/assets/image/icon/img_lazyload.png"),
      iconSound: require("@/assets/image/icon/icon_sound.png")
    };
  },

  methods: {
    moreResult(code) {
      // console.log(code);
      let obj = {};
      obj["router"] = this.$router;
      obj["path"] = this.UTILS.splitUrl("searchResult");
      obj["query"] = { code: code, key: this.keyWord };
      this.GLOBAL_.ccApp.openTo(obj);
    },
    gotoDetail(id, code) {
      let obj = {};
      obj["router"] = this.$router;
      if (code != "ebook" && code != "video") {
        obj["path"] = this.UTILS.splitUrl("detail");
        obj["query"] = { id: id };
        this.GLOBAL_.ccApp.openTo(obj);
      } else if (code == "ebook") {
        obj["path"] = this.UTILS.splitUrl("ebookDetail");
        obj["query"] = { id: id };
        this.GLOBAL_.ccApp.openTo(obj);
      } else if (code == "video") {
        obj["path"] = this.UTILS.splitUrl("videoDetail");
        obj["query"] = { id: id };
        this.GLOBAL_.ccApp.openTo(obj);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/searchBlock.vue